import { capitalize } from '@superbet-group/web.lib.utilities';
import store from '@globalStore';

import { checkIfResident } from './_private/helpers';
import { GetPlayerDetailsResponse } from '../user/_private/Types';
import { getAccountConfig } from '@accountFederation/config/accountConfig';

type RawUser = GetPlayerDetailsResponse['data'];
interface RawPlayerData {
    userId: RawUser['userId'];
    externalGameId: RawUser['externalGameId'];
    externalUUID?: RawUser['externalUUID'];
    hasMadeDeposit: RawUser['hasMadeDeposit'];
    username: RawUser['username'];
    firstName: RawUser['firstName'];
    lastName: RawUser['lastName'];
    dateOfBirth: RawUser['dateOfBirth'];
    phone: RawUser['phone'];
    address: RawUser['address'];
    city: RawUser['city'];
    county: RawUser['county'];
    countryId: RawUser['countryId'];
    postalCode: RawUser['postalCode'];
    email: RawUser['email'];
    shouldVerifySms: RawUser['shouldVerifySms'];
    generalPrivacy: RawUser['generalPrivacy'];
    customPrivacy: RawUser['customPrivacy'];
    contactPreferences: RawUser['contactPreferences'];
    lastSession: RawUser['lastSession'];
    firstDepositDate: RawUser['firstDepositDate'];
    registrationDate: RawUser['registrationDate'];
    kycChecked: RawUser['kycChecked'];
    nationality: RawUser['nationality'];
    gender?: RawUser['gender'];
    sessionId?: RawUser['sessionId'];
    locale?: RawUser['locale'];
    isVip?: RawUser['isVip'];
    userUuid: RawUser['userUuid'];
    welcomeBonus: RawUser['welcomeBonus'];
    identityDocuments: RawUser['identityDocuments']
    reKycStatus?: RawUser['reKycStatus'];
    useMfa?: RawUser['useMfa'];
}

export function getDetails(data: RawPlayerData) {
    let firstDepositDate: false | Date = false;
    if (typeof data.firstDepositDate === 'string') {
        firstDepositDate = new Date(data.firstDepositDate);
    }

    return {
        firstDepositDate,
        isResident: checkIfResident(data),
        userId: data.userId,
        externalGameId: data.externalGameId,
        externalUUID: data.externalUUID,
        hasMadeDeposit: data.hasMadeDeposit,
        username: data.username,
        firstName: data.firstName,
        lastName: data.lastName,
        fullName: capitalize(data?.firstName + ' ' || '') + capitalize(data?.lastName || ''),
        dateOfBirth: data.dateOfBirth,
        phone: data.phone,
        address: data.address,
        city: data.city,
        county: data.county,
        countryId: data.countryId,
        postalCode: data.postalCode,
        email: data.email,
        registrationDate: new Date(data.registrationDate),
        shouldVerifySms: data.shouldVerifySms,
        acceptsGeneralPrivacy: data.generalPrivacy,
        acceptsCustomPrivacy: data.customPrivacy,
        acceptsContactPreferences: data.contactPreferences,
        isVerifiedIdCard: data.kycChecked,
        isTempAccount: !data.kycChecked,
        lastSession: data.lastSession,
        locale: data.locale,
        isVip: data.isVip,
        userUuid: data.userUuid,
        welcomeBonus: data.welcomeBonus,
        reKycStatus: data.reKycStatus,
        identityDocuments: data.identityDocuments,
        ...(data.useMfa ? { isMfaPreferenceEnabled: data.useMfa } : {}),
        ...(data.sessionId ? { sessionId: data.sessionId } : {}),
        ...(getAccountConfig().hasGenderAndNationalityRequirement
            ? {
                nationality: data.nationality || undefined,
                gender: data.gender,
            }
            : {}
        ),
    };
}

export function getCsrfToken(): Optional<string> {
    return store.getters['data/authentication/csrfToken'];
}
